module.exports = __webpack_public_path__ + "img/audas_pro_logo.f2fcc0eb.jpg";